module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousAir
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": ""
    }
  }, [_c('h2', [_vm._v("Tracking(Sea Conso)")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Assignment No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.mainPageModal.conSeaImportSeries),
      callback: function($$v) {
        _vm.$set(_vm.mainPageModal, "conSeaImportSeries", $$v)
      },
      expression: "mainPageModal.conSeaImportSeries"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "conSeaMultiBlId"
    }
  }, [_vm._v("HAWBL No.")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "conSeaMultiBlId",
      "option-text": "secondBLNumber",
      "list": _vm.HAWBLNoList,
      "placeholder": "Select HAWBL No."
    },
    model: {
      value: (_vm.docModal.conSeaMultiBlId),
      callback: function($$v) {
        _vm.$set(_vm.docModal, "conSeaMultiBlId", $$v)
      },
      expression: "docModal.conSeaMultiBlId"
    }
  }), _vm._v(" "), (!_vm.docModal.conSeaMultiBlId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.conSeaMultiBlId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "trackingDoc"
    }
  }, [_vm._v("Document")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "trackingDocVal",
      "option-text": "trackingDocText",
      "list": _vm.trackingDocList,
      "placeholder": "Select Document "
    },
    model: {
      value: (_vm.docModal.trackingDoc),
      callback: function($$v) {
        _vm.$set(_vm.docModal, "trackingDoc", $$v)
      },
      expression: "docModal.trackingDoc"
    }
  }), _vm._v(" "), (!_vm.docModal.trackingDoc) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.trackingDoc))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload Document")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "trackDocUpload",
      "id": "trackDocUpload",
      "multiple": ""
    },
    on: {
      "selected": _vm.onFileChangetracking
    },
    model: {
      value: (_vm.docModal.trackDocUpload),
      callback: function($$v) {
        _vm.$set(_vm.docModal, "trackDocUpload", $$v)
      },
      expression: "docModal.trackDocUpload"
    }
  })], 1), _vm._v(" "), (!_vm.docModal.trackDocUpload) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.trackDocUpload))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Receiving Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "receivingDate",
      "name": "receivingDate"
    },
    model: {
      value: (_vm.docModal.receivingDate),
      callback: function($$v) {
        _vm.$set(_vm.docModal, "receivingDate", $$v)
      },
      expression: "docModal.receivingDate"
    }
  }), _vm._v(" "), (!_vm.docModal.receivingDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.receivingDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "addButtonLoader1"
    },
    on: {
      "click": function($event) {
        _vm.addTrack('')
      }
    }
  }, [_vm._v("Upload")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1), _vm._v(" "), (_vm.trackingUploadView.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }), _vm._v(" "), _vm._l((_vm.trackingUploadView), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "15"
      }
    }, [_c('a', {
      attrs: {
        "href": (this.docURL) + "/dummy" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.docTableData.length > 0) ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e(), _vm._v(" "), (_vm.docTableData.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Document Details")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "ffBookingTentative"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("HAWBL No.")]), _vm._v(" "), _c('th', [_vm._v("Document")]), _vm._v(" "), _c('th', [_vm._v("Receiving Date")]), _vm._v(" "), _c('th', [_vm._v("View Doc")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.docTableData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.HAWBLNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.trackingDoc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.receivingDate)))]), _vm._v(" "), _c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.viewDoc(item.trackDocUpload)
        }
      }
    }, [_c('md-icon', [_vm._v("visibility")])], 1)], 1)
  }))])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), (_vm.mainPageModal.cargoDestufLocationId != _vm.mainPageModal.PODLocationId) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('h3', [_c('u', [_vm._v("Rail Out")])])])], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Destuffing Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "arivalDatePort",
      "name": "arivalDatePort"
    },
    model: {
      value: (_vm.BookingShippingLine.destuffingDate),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "destuffingDate", $$v)
      },
      expression: "BookingShippingLine.destuffingDate"
    }
  })], 1)], 1), _vm._v(" "), (_vm.mainPageModal.cargoDestufLocationId != _vm.mainPageModal.PODLocationId) ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Train No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "trainNo",
      "id": "trainNo"
    },
    model: {
      value: (_vm.BookingShippingLine.trainNo),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "trainNo", $$v)
      },
      expression: "BookingShippingLine.trainNo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Wagon No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "wagonNo",
      "id": "wagonNo"
    },
    model: {
      value: (_vm.BookingShippingLine.wagonNo),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "wagonNo", $$v)
      },
      expression: "BookingShippingLine.wagonNo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "trainDate",
      "name": "trainDate"
    },
    model: {
      value: (_vm.BookingShippingLine.trainDate),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "trainDate", $$v)
      },
      expression: "BookingShippingLine.trainDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.mainPageModal.cargoDestufLocationId != _vm.mainPageModal.PODLocationId) ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Actual Arrival Date(FPOD)")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "actualAriveDateFPOD",
      "name": "actualAriveDateFPOD"
    },
    model: {
      value: (_vm.BookingShippingLine.actualAriveDateFPOD),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "actualAriveDateFPOD", $$v)
      },
      expression: "BookingShippingLine.actualAriveDateFPOD"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    attrs: {
      "id": "addButtonLoader1"
    },
    on: {
      "click": function($event) {
        _vm.addTrack('pqrst')
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop2",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseProceed
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopAddTracking",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAddTracking
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46e4591c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/conSeaImport/conSeaImportTracking.vue
// module id = 2579
// module chunks = 0